const asyncProto = Object.getPrototypeOf(async () => {})

export const isAsyncFn = x => Object.getPrototypeOf(x) === asyncProto
